import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import dayjs from "dayjs";
import APICall from "../../../../components/Api/APICall";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: `${dayjs().format("MMMM")} month Product sale Quantity`,
    },
  },
};

export default function ProductBarGrapghComponent() {
  const [MonthCylenderSaleData, setMonthCylenderSaleData] = useState([]);
  const [Labels, setLabels] = useState([]);
  useEffect(() => {
    APICall("/service/monthlyProductSale").then((responce) => {
      if (responce.status) {
        setMonthCylenderSaleData(responce.message.map(v=>v.quantity));
        setLabels(responce.message.map(v=>v.productName))
      }
    });
  }, []);

  const data = {
    labels:Labels,
    datasets: [
      {
        label: "Sale",
        data: MonthCylenderSaleData,
        backgroundColor: ["green"],
      },
    ],
  };
  return (
    <>
      <Bar height={"210px"} options={options} data={data} className="w-full" />
    </>
  );
}
